import { Col, Row } from '@qonsoll/react-design'
import { CountryFilter, CountryTable } from 'domains/Country/components'
import {
  HeaderBreadcrumbs,
  PageActions,
  PageWrapperActionsUnderTitle,
  Spinner
} from 'components'
import { useCountryBaseActions, useGetCountries } from 'domains/Country/hooks'
import { useMemo, useState } from 'react'

import PropTypes from 'prop-types'
import { useFilter } from 'hooks'
import { useTranslations } from 'contexts/Translation'

const CountriesAll = (props) => {
  const { withHeader = true } = props

  const [filteredCountriesCollection, setFilteredCountriesCollection] =
    useState()

  /* Getting translations instance */
  const { t } = useTranslations()

  /* Getting filter params */
  const filterParams = useFilter('country')

  /* Destructuring filter params */
  const { filterVisibility, filterData, setFilterVisibility } = filterParams

  /* Building filter query */
  const ref = useMemo(() => filterData, [filterData])

  /* Fetching countries */
  const [countries, loading] = useGetCountries(ref)

  /* Getting base actions */
  const listActions = useCountryBaseActions()

  /* Configuring page header */
  const headingProps = {
    title: t('Countries'),
    titleSize: 3,
    marginBottom: 3,
    textAlign: 'left'
  }

  /* Configuring page actions */
  const actions = {
    filter: true,
    search: true
  }

  /* Extracting base actions */
  const { onBack, onCreate } = listActions

  return (
    <PageWrapperActionsUnderTitle
      action={
        withHeader ? (
          <PageActions
            {...filterParams}
            onCreate={onCreate}
            actions={actions}
            circle
            filterMenu={<CountryFilter {...filterParams} />}
            collection={countries}
            setCollection={setFilteredCountriesCollection}
            searchField="internationalName"
            searchPlaceholder="Search by Country"
            filterVisibility={filterVisibility}
            setFilterVisibility={setFilterVisibility}
          />
        ) : null
      }
      onBack={withHeader ? onBack : null}
      breadcrumbs={withHeader ? <HeaderBreadcrumbs /> : null}
      headingProps={withHeader ? headingProps : null}>
      <Row noGutters>
        {loading ? (
          <Col>
            <Spinner height="70vh" text={t('Country loading')} />
          </Col>
        ) : (
          <Col cw={12}>
            <CountryTable
              dataSource={filteredCountriesCollection ?? countries}
            />
          </Col>
        )}
      </Row>
    </PageWrapperActionsUnderTitle>
  )
}

CountriesAll.propTypes = {
  isListWithCreate: PropTypes.bool,
  withHeader: PropTypes.bool
}

export default CountriesAll
